module.exports = __webpack_public_path__ + "img/_6.38102bdd.png";